import BaseExtension from './base';

import createElement from '../utils/createElement';
import createSvg, { PREV_TRACK } from '../svgs';

const CN = 'rmp-ext-prev';
const BUTTON_CN = `${CN}__button`;
const THUMBNAIL_CN = `${CN}__thumbnail`;

export default class PrevExtension extends BaseExtension {
   /** @type {HTMLElement} */
   $outer;
   /** @type {HTMLButtonElement} */
   $button;

   constructor(player, state, options) {
      super(player, state, options);
      this.logger.debug('prev:extension:creating');

      this.render();

      const bus = this.options.bus;

      this.addEvent(this.$outer, 'click', () => bus.emit('prevtrack') );

      this.logger.debug('prev:extension:created');
   }

   render() {
      const title = this.options.prevTrackTitle;
      this.$outer = createElement('div', { class: CN, title });
      this.$button = createElement('button', { type: 'button', class: BUTTON_CN }, this.$outer);
      createSvg(this.$button, PREV_TRACK);
      this.$button.setAttribute('aria-label', 'Go to previous track');

      createElement('img', { src: this.options.prevTrackThumbnails, class: THUMBNAIL_CN }, this.$outer);
   }

   getOuter() {
      return this.$outer;
   }

   destroy() {
      super.destroy();
      this.$outer.parentNode.removeChild(this.$outer);
      this.$outer = null;
   }
}
